var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCloseCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ant-design:close-circle-outlined"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M10.8805 6.01861C10.8805 5.94916 10.8237 5.89233 10.7542 5.89233L9.71242 5.89707L8.14338 7.7676L6.57592 5.89865L5.53253 5.89391C5.46308 5.89391 5.40625 5.94916 5.40625 6.02019C5.40625 6.05018 5.4173 6.0786 5.43624 6.10228L7.48988 8.54896L5.43624 10.9941C5.41717 11.0172 5.40658 11.0462 5.40625 11.0762C5.40625 11.1456 5.46308 11.2024 5.53253 11.2024L6.57592 11.1977L8.14338 9.32717L9.71084 11.1961L10.7527 11.2009C10.8221 11.2009 10.8789 11.1456 10.8789 11.0746C10.8789 11.0446 10.8679 11.0162 10.8489 10.9925L8.79846 8.54738L10.8521 6.1007C10.871 6.0786 10.8805 6.04861 10.8805 6.01861Z",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M8.14202 1.44141C4.2368 1.44141 1.07031 4.60789 1.07031 8.51312C1.07031 12.4183 4.2368 15.5848 8.14202 15.5848C12.0473 15.5848 15.2137 12.4183 15.2137 8.51312C15.2137 4.60789 12.0473 1.44141 8.14202 1.44141ZM8.14202 14.3852C4.89977 14.3852 2.26998 11.7554 2.26998 8.51312C2.26998 5.27086 4.89977 2.64107 8.14202 2.64107C11.3843 2.64107 14.0141 5.27086 14.0141 8.51312C14.0141 11.7554 11.3843 14.3852 8.14202 14.3852Z",
    fill: "#333333"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseCircle);
export default __webpack_public_path__ + "static/media/closeCircle.2e72805bd7eeea3b9baf831a414b050a.svg";
export { ForwardRef as ReactComponent };